import { useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const testimonials = [
  {
    quote: "ECONATION a transformé notre approche de l'efficacité énergétique. En 9 mois, 4 sites audités, 2,1 M€ de CEE valorisés et une roadmap claire jusqu'en 2030.",
    name: "Antoine M.",
    role: "Directeur Industriel",
    company: "Groupe agroalimentaire · 6 sites",
  },
  {
    quote: "Un sérieux et une rigueur technique rares dans ce métier. Le bureau d'études interne a redimensionné notre installation de froid : 38 % d'économies vérifiées la 1ʳᵉ année.",
    name: "Sophie L.",
    role: "Responsable Maintenance",
    company: "Plateforme logistique · 42 000 m²",
  },
  {
    quote: "Une réactivité exceptionnelle. Notre dossier de Coup de Pouce Chaufferie a été monté, déposé et validé en 6 semaines. Aucun autre acteur n'a su tenir ce délai.",
    name: "Jean-Pierre R.",
    role: "Directeur Technique",
    company: "Groupe hôtelier · 11 établissements",
  },
  {
    quote: "Au-delà du financement, ECONATION nous accompagne dans la mesure et la vérification. Un vrai partenaire long terme — pas un simple courtier CEE.",
    name: "Camille D.",
    role: "Gestionnaire de patrimoine",
    company: "Foncière tertiaire · 280 000 m²",
  },
  {
    quote: "Audit clair, chiffres tenus, travaux pilotés de bout en bout. La copropriété a réduit sa facture de 31 % avec un reste à charge proche de zéro.",
    name: "Marc T.",
    role: "Président de Conseil Syndical",
    company: "Copropriété · 184 lots",
  },
];

export default function TestimonialSlider() {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "start" });
  const [selected, setSelected] = useState(0);
  const [count, setCount] = useState(0);

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelected(embla.selectedScrollSnap());
  }, [embla]);

  useEffect(() => {
    if (!embla) return;
    setCount(embla.scrollSnapList().length);
    embla.on("select", onSelect);
    onSelect();
  }, [embla, onSelect]);

  return (
    <section data-testid="testimonial-slider" className="bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Ce qu&apos;ils en disent</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight text-balance leading-[1.05]">
              La confiance de directeurs industriels, exploitants et gestionnaires de patrimoine.
            </h2>
          </div>
          <div className="flex gap-2">
            <button
              data-testid="testimonial-prev"
              onClick={() => embla?.scrollPrev()}
              aria-label="Précédent"
              className="h-12 w-12 rounded-full border border-black/10 grid place-items-center hover:bg-black/[0.04] transition-colors"
            >
              <ChevronLeft className="h-5 w-5 text-[#0F172A]" />
            </button>
            <button
              data-testid="testimonial-next"
              onClick={() => embla?.scrollNext()}
              aria-label="Suivant"
              className="h-12 w-12 rounded-full bg-[#0F172A] text-white grid place-items-center hover:bg-[#064E3B] transition-colors"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex gap-6">
            {testimonials.map((t, i) => (
              <article
                key={i}
                data-testid={`testimonial-${i}`}
                className="flex-[0_0_92%] sm:flex-[0_0_70%] lg:flex-[0_0_46%] xl:flex-[0_0_38%] bg-gradient-to-br from-[#F8FAFC] to-white border border-black/[0.06] rounded-2xl p-8 md:p-10"
              >
                <Quote className="h-10 w-10 text-[#10B981]/30 mb-6" />
                <p className="font-display text-lg md:text-xl text-[#0F172A] leading-snug mb-8">
                  « {t.quote} »
                </p>
                <div className="pt-6 border-t border-black/[0.06]">
                  <div className="font-display font-semibold text-[#0F172A]">{t.name}</div>
                  <div className="text-sm text-[#475569] mt-0.5">{t.role}</div>
                  <div className="text-xs text-[#94A3B8] mt-1">{t.company}</div>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-10">
          {Array.from({ length: count }).map((_, i) => (
            <button
              key={i}
              onClick={() => embla?.scrollTo(i)}
              aria-label={`Avis ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${selected === i ? "w-8 bg-[#10B981]" : "w-1.5 bg-black/15"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
